<template>
    <div style="padding:10px">
        <el-row>
            <el-button-group>
                <el-button round type="success" @click="openCreate">创建</el-button>
            </el-button-group>
        </el-row>

        <el-row style="padding:20px 0">
            <el-col :span="24">
                <el-table ref="dataViewTable" :data="dataViewList" row-key="id" style="width: 100%">
                    <el-table-column width="40">
                        <template #default>
                            <span class="drag-handle table-drag-handle"><i></i><i></i><i></i></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="100">
                        <template #default="scope">
                            <el-tag v-if="scope.row.isEnable" size="medium" type="success">启用</el-tag>
                            <el-tag v-else size="medium" type="danger">停用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="视图名称" width="220"></el-table-column>
                    <el-table-column prop="description" label="描述信息"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                    <el-table-column label="操作" width="220">
                        <template #default="scope">
                            <el-button @click="openEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="toggleEnable(scope.row)" type="text" size="small">启用/停用</el-button>

                            <el-popover placement="top-start" :width="200" trigger="click">
                                <p>删除操作不可撤回，确定删除吗？</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button type="danger" size="mini" @click="remove(scope.row)">确定</el-button>
                                </div>
                                <template #reference>
                                    <el-button type="text" size="small">删除</el-button>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>

    <!-- Form -->
    <el-dialog :title="dialogFormMode == 'create' ? '创建数据视图' : '编辑数据视图'" v-model="dialogFormVisible"
        width="80%" top="5vh" :close-on-click-modal="false">
        <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="base">
                <div class="info-section">
                    <div class="info-section-title">基本信息</div>
                    <div class="info-section-body">
                        <el-form :model="dataForm" label-width="100px">
                            <el-form-item label="视图名称">
                                <el-input v-model="dataForm.name" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="描述信息">
                                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="dataForm.description">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">样式</div>
                    <div class="info-section-body">
                        <el-form :model="dataForm.style" label-width="100px">
                            <el-form-item label="头像">
                                <el-input v-model="dataForm.style.avatar" placeholder="头像地址"></el-input>
                            </el-form-item>
                            <el-form-item label="背景">
                                <el-input v-model="dataForm.style.background" placeholder="背景图地址"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">团队</div>
                    <div class="info-section-body">
                        <el-select v-model="dataForm.teamIdList" multiple filterable placeholder="选择团队" style="width:100%">
                            <el-option v-for="team in ownerTeams" :key="team.id" :label="team.name"
                                :value="team.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane label="数据源" name="sources">
                <div class="info-section">
                    <div class="info-section-title">数据库源</div>
                    <div class="info-section-body">
                        <el-button type="success" size="small" @click="addSrcDb">添加数据库源</el-button>
                        <div v-for="(item, index) in dataForm.srcDbs" :key="index" class="jsonb-item">
                            <el-row :gutter="10">
                                <el-col :span="6"><el-input v-model="item.name" placeholder="名称" /></el-col>
                                <el-col :span="6"><el-input v-model="item.url" placeholder="URL" /></el-col>
                                <el-col :span="6">
                                    <el-select v-model="item.type" placeholder="类型" clearable style="width:100%">
                                        <el-option label="MySQL" value="mysql"></el-option>
                                        <el-option label="PostgreSQL" value="postgresql"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="6"><el-input v-model="item.driverClass" placeholder="驱动类" /></el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin-top:10px">
                                <el-col :span="12"><el-input v-model="item.userName" autocomplete="off" placeholder="用户名" /></el-col>
                                <el-col :span="12"><el-input v-model="item.password" type="password" show-password
                                        autocomplete="new-password" placeholder="密码" /></el-col>
                            </el-row>
                            <el-button type="danger" size="small" style="margin-top:10px"
                                @click="removeItem(dataForm.srcDbs, index)">删除</el-button>
                        </div>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">SSH源</div>
                    <div class="info-section-body">
                        <el-button type="success" size="small" @click="addSrcSsh">添加SSH源</el-button>
                        <div v-for="(item, index) in dataForm.srcSshs" :key="index" class="jsonb-item">
                            <el-row :gutter="10">
                                <el-col :span="8"><el-input v-model="item.name" placeholder="名称" /></el-col>
                                <el-col :span="8"><el-input v-model="item.ip" placeholder="IP" /></el-col>
                                <el-col :span="8"><el-input v-model="item.port" placeholder="端口" /></el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin-top:10px">
                                <el-col :span="12"><el-input v-model="item.userName" autocomplete="off" placeholder="用户名" /></el-col>
                                <el-col :span="12"><el-input v-model="item.password" type="password" show-password
                                        autocomplete="new-password" placeholder="密码" /></el-col>
                            </el-row>
                            <el-button type="danger" size="small" style="margin-top:10px"
                                @click="removeItem(dataForm.srcSshs, index)">删除</el-button>
                        </div>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">URL源</div>
                    <div class="info-section-body">
                        <el-button type="success" size="small" @click="addSrcUrl">添加URL源</el-button>
                        <div v-for="(item, index) in dataForm.srcUrls" :key="index" class="jsonb-item">
                            <el-row :gutter="10">
                                <el-col :span="8"><el-input v-model="item.name" placeholder="名称" /></el-col>
                                <el-col :span="8"><el-input v-model="item.url" placeholder="URL" /></el-col>
                                <el-col :span="8">
                                    <el-select v-model="item.type" placeholder="类型" style="width:100%">
                                        <el-option label="GET" value="GET"></el-option>
                                        <el-option label="POST" value="POST"></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <el-button type="danger" size="small" style="margin-top:10px"
                                @click="removeItem(dataForm.srcUrls, index)">删除</el-button>
                        </div>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">ES源</div>
                    <div class="info-section-body">
                        <el-button type="success" size="small" @click="addSrcEs">添加ES源</el-button>
                        <div v-for="(item, index) in dataForm.srcEs" :key="index" class="jsonb-item">
                            <el-row :gutter="10">
                                <el-col :span="8"><el-input v-model="item.name" placeholder="名称" /></el-col>
                                <el-col :span="16"><el-input v-model="item.serverUrl" placeholder="ServerUrl" /></el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin-top:10px">
                                <el-col :span="12"><el-input v-model="item.username" autocomplete="off" placeholder="用户名" /></el-col>
                                <el-col :span="12"><el-input v-model="item.password" type="password" show-password
                                        autocomplete="new-password" placeholder="密码" /></el-col>
                            </el-row>
                            <el-button type="danger" size="small" style="margin-top:10px"
                                @click="removeItem(dataForm.srcEs, index)">删除</el-button>
                        </div>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane label="区块配置" name="sections">
                <div ref="sectionList" class="section-list">
                    <div v-for="section in dataForm.sections" :key="section._id" class="section-box"
                        :data-section-id="section._id" :style="sectionBoxStyle(section)">
                        <div class="section-box-header">
                            <span class="drag-handle section-drag-handle"><i></i><i></i><i></i></span>
                            <el-input v-model="section.name" placeholder="区块名称" size="small"
                                class="section-name-input" />
                            <el-button size="small" type="danger" @click.stop="removeSection(section)">删除</el-button>
                        </div>
                        <div class="card-list">
                            <div v-for="card in section.cards" :key="card._id" class="card-box" :data-card-id="card._id">
                                <div class="card-box-header">
                                    <span class="drag-handle card-drag-handle"><i></i><i></i><i></i></span>
                                    <el-input v-model="card.name" placeholder="卡片名称" size="small"
                                        class="card-name-input" />
                                    <el-select v-model="card.type" placeholder="卡片类型" clearable size="small"
                                        class="card-type-select">
                                        <el-option v-for="t in cardTypeOptions" :key="t.value" :label="t.label"
                                            :value="t.value">
                                            <el-tooltip :content="t.desc" placement="right">
                                                <span>{{ t.label }}</span>
                                            </el-tooltip>
                                        </el-option>
                                    </el-select>
                                    <el-cascader v-model="card._src" :options="srcCascaderOptions"
                                        placeholder="数据源" clearable size="small"
                                        class="card-src-select" @change="v => onCascaderChange(card, v)" />
                                    <el-button size="small" type="danger" @click.stop="removeCard(card)">删除</el-button>
                                </div>
                                <div class="card-box-body">
                                    <el-input v-model="card.paramsText" type="textarea" :rows="6"
                                        placeholder="参数(JSON格式)" size="small" />
                                </div>
                            </div>
                        </div>
                        <div class="add-card-btn-wrap">
                            <el-button type="primary" size="small" plain class="add-card-btn"
                                @click="addCard(section)">+ 添加卡片</el-button>
                        </div>
                    </div>
                </div>
                <div style="margin-top:10px; text-align:center">
                    <el-button type="success" size="small" plain class="add-section-btn" style="width: 240px" @click="addSection">+ 添加区块</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">保 存</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import Sortable from 'sortablejs';
import request from '../../../utils/request.js';

function emptyDataForm() {
    return {
        name: '',
        description: '',
        isEnable: false,
        style: { avatar: '', background: '' },
        srcDbs: [],
        srcSshs: [],
        srcUrls: [],
        srcEs: [],
        sections: [],
        teamIdList: []
    };
}

export default {
    data() {
        return {
            dialogFormMode: 'create',
            dialogFormVisible: false,
            activeTab: 'base',
            dataForm: emptyDataForm(),
            currentId: '',
            dataViewList: [],
            ownerTeams: [],
            treeSeq: 0,
            sortables: [],
            tableSortable: null,
            sectionColors: [
                { bg: '#eef4ff', border: '#b7d1f7' },
                { bg: '#eefaf1', border: '#b5e0c0' },
                { bg: '#fdf6e3', border: '#f0dfa0' },
                { bg: '#fef3e7', border: '#f5d3a8' },
                { bg: '#fdf0f3', border: '#f5c6d2' },
                { bg: '#f4f0fb', border: '#d8c7f0' },
                { bg: '#eefafb', border: '#b7e3e6' }
            ],
            cardTypeOptions: [
                { value: 'card-chart-bar', label: '横向柱状图', desc: '条形图，柱子水平摆放' },
                { value: 'card-chart-column', label: '纵向柱状图', desc: '柱形图，柱子垂直摆放' },
                { value: 'card-chart-line', label: '折线图', desc: '趋势折线图表' },
                { value: 'card-chart-pie', label: '饼图', desc: '占比饼状图表' },
                { value: 'card-text', label: '文本', desc: '纯文字/指标文本展示卡片' },
                { value: 'card-table', label: '表格', desc: '表格形式展示数据' }
            ]
        };
    },
    mounted() {
        this.loadList().then(() => this.initTableSortable());
        this.loadOwnerTeams();
    },
    watch: {
        activeTab(val) {
            if (val === 'sections' && this.dialogFormVisible) {
                this.$nextTick(() => this.initSortables());
            }
        },
        dialogFormVisible(val) {
            if (!val) this.destroySortables();
        }
    },
    computed: {
        srcCascaderOptions() {
            const build = list => list.map(x => ({ value: x.id, label: x.name || x.id }));
            const make = (value, label, list) => {
                const children = build(list);
                return { value, label, children, disabled: children.length === 0 };
            };
            return [
                make('db', '数据库', this.dataForm.srcDbs),
                make('ssh', 'SSH', this.dataForm.srcSshs),
                make('url', 'URL', this.dataForm.srcUrls),
                make('es', 'ES', this.dataForm.srcEs)
            ];
        }
    },
    methods: {
        loadList() {
            return request({
                url: '/dataview/list',
                method: 'post',
                data: {}
            }).then(res => {
                if (res.code == 0) {
                    this.dataViewList = res.meta.dataViews || [];
                }
            });
        },
        loadOwnerTeams() {
            return request({
                url: '/team/getOwnerTeams',
                method: 'post',
                data: {}
            }).then(res => {
                if (res.code == 0) {
                    this.ownerTeams = res.data || [];
                }
            });
        },
        initTableSortable() {
            this.$nextTick(() => {
                const table = this.$refs.dataViewTable;
                if (!table) return;
                const tbody = table.$el.querySelector('.el-table__body-wrapper tbody');
                if (!tbody) return;
                if (this.tableSortable) {
                    this.tableSortable.destroy();
                    this.tableSortable = null;
                }
                this.tableSortable = Sortable.create(tbody, {
                    animation: 150,
                    handle: '.table-drag-handle',
                    onEnd: (evt) => this.handleTableDragEnd(evt)
                });
            });
        },
        handleTableDragEnd(evt) {
            const { oldIndex, newIndex } = evt;
            if (oldIndex === newIndex) return;
            const moved = this.dataViewList.splice(oldIndex, 1)[0];
            this.dataViewList.splice(newIndex, 0, moved);
            const ids = this.dataViewList.map(x => x.id);
            request({
                url: '/dataview/sort',
                method: 'post',
                data: { ids }
            }).then(res => {
                this.loadList().then(() => this.initTableSortable());
            });
        },
        openCreate() {
            this.dialogFormMode = 'create';
            this.currentId = '';
            this.dataForm = emptyDataForm();
            this.activeTab = 'base';
            this.dialogFormVisible = true;
        },
        openEdit(row) {
            this.dialogFormMode = 'edit';
            this.currentId = row.id;
            this.dataForm = this.toEditForm(row);
            this.activeTab = 'base';
            this.dialogFormVisible = true;
        },
        toEditForm(row) {
            return {
                name: row.name || '',
                description: row.description || '',
                isEnable: !!row.isEnable,
                style: row.style || { avatar: '', background: '' },
                srcDbs: (row.srcDbs || []).map(x => ({ ...x })),
                srcSshs: (row.srcSshs || []).map(x => ({ ...x })),
                srcUrls: (row.srcUrls || []).map(x => ({ ...x })),
                srcEs: (row.srcEs || []).map(x => ({ ...x })),
                sections: (row.sections || []).map((s, idx) => ({
                    _id: this.genId(),
                    name: s.name || '',
                    remark: s.remark || '',
                    _colorIndex: idx,
                    cards: (s.cards || []).map(c => ({
                        _id: this.genId(),
                        name: c.name || '',
                        type: c.type || '',
                        srcId: c.srcId || '',
                        srcType: c.srcType || '',
                        _src: c.srcType ? (c.srcId ? [c.srcType, c.srcId] : [c.srcType]) : [],
                        paramsText: c.params ? JSON.stringify(c.params, null, 2) : '',
                        remark: c.remark || ''
                    }))
                })),
                teamIdList: row.teamIdList || []
            };
        },
        toSubmitData() {
            const form = this.dataForm;
            return {
                name: form.name,
                description: form.description,
                isEnable: form.isEnable,
                style: form.style,
                srcDbs: form.srcDbs,
                srcSshs: form.srcSshs,
                srcUrls: form.srcUrls,
                srcEs: form.srcEs,
                sections: form.sections.map(s => ({
                    name: s.name,
                    remark: s.remark,
                    cards: s.cards.map(c => ({
                        name: c.name,
                        type: c.type,
                        srcId: c.srcId,
                        srcType: c.srcType,
                        params: c.paramsText && c.paramsText.trim() ? JSON.parse(c.paramsText) : null,
                        remark: c.remark
                    }))
                })),
                teamIdList: form.teamIdList
            };
        },
        save() {
            let data;
            try {
                data = this.toSubmitData();
            } catch (e) {
                ElMessage({ message: '卡片参数格式错误，请填写合法的 JSON', type: 'error', duration: 3 * 1000 });
                return;
            }

            if (this.dialogFormMode == 'create') {
                return request({
                    url: '/dataview/create',
                    method: 'post',
                    data: data
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.loadList();
                    }
                });
            }
            if (this.dialogFormMode == 'edit') {
                return request({
                    url: '/dataview/edit',
                    method: 'post',
                    data: Object.assign({ id: this.currentId }, data)
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.loadList();
                    }
                });
            }
        },
        toggleEnable(row) {
            return request({
                url: '/dataview/enable',
                method: 'post',
                data: { id: row.id, enable: !row.isEnable }
            }).then(res => {
                if (res.code == 0) {
                    this.loadList();
                }
            });
        },
        remove(row) {
            return request({
                url: '/dataview/delete',
                method: 'post',
                data: { id: row.id }
            }).then(res => {
                if (res.code == 0) {
                    this.loadList();
                }
            });
        },
        addSrcDb() {
            this.dataForm.srcDbs.push({
                id: this.nextId(this.dataForm.srcDbs), name: '', url: '', type: '', userName: '',
                password: '', driverClass: '', remark: ''
            });
        },
        addSrcSsh() {
            this.dataForm.srcSshs.push({
                id: this.nextId(this.dataForm.srcSshs), name: '', ip: '', port: '', userName: '',
                password: '', remark: ''
            });
        },
        addSrcUrl() {
            this.dataForm.srcUrls.push({ id: this.nextId(this.dataForm.srcUrls), name: '', url: '', type: 'GET', remark: '' });
        },
        addSrcEs() {
            this.dataForm.srcEs.push({
                id: this.nextId(this.dataForm.srcEs), name: '', serverUrl: '', username: '',
                password: '', remark: ''
            });
        },
        nextId(list) {
            let max = 0;
            list.forEach(item => {
                const n = parseInt(item.id, 10);
                if (!isNaN(n) && n > max) max = n;
            });
            return String(max + 1);
        },
        onCascaderChange(card, value) {
            if (Array.isArray(value) && value.length > 0) {
                card.srcType = value[0];
                card.srcId = value.length > 1 ? value[1] : '';
            } else {
                card.srcType = '';
                card.srcId = '';
            }
        },
        addSection() {
            this.dataForm.sections.push({
                _id: this.genId(), name: '', remark: '',
                _colorIndex: this.dataForm.sections.length,
                cards: []
            });
            this.$nextTick(() => this.initSortables());
        },
        addCard(section) {
            const card = {
                _id: this.genId(), name: '', type: '', srcId: '', srcType: '', _src: [],
                paramsText: '', remark: ''
            };
            section.cards.push(card);
            this.$nextTick(() => this.initSortables());
        },
        removeItem(list, index) {
            list.splice(index, 1);
        },
        removeSection(data) {
            const idx = this.dataForm.sections.findIndex(s => s._id === data._id);
            if (idx >= 0) {
                this.dataForm.sections.splice(idx, 1);
                this.$nextTick(() => this.initSortables());
            }
        },
        removeCard(data) {
            for (const section of this.dataForm.sections) {
                const idx = section.cards.findIndex(c => c._id === data._id);
                if (idx >= 0) {
                    section.cards.splice(idx, 1);
                    this.$nextTick(() => this.initSortables());
                    return;
                }
            }
        },
        genId() {
            this.treeSeq += 1;
            return 'n' + this.treeSeq;
        },
        sectionBoxStyle(section) {
            const idx = (section._colorIndex || 0) % this.sectionColors.length;
            const c = this.sectionColors[idx];
            return { background: c.bg, borderColor: c.border };
        },
        initSortables() {
            this.destroySortables();
            const listEl = this.$refs.sectionList;
            if (!listEl) return;

            this.sortables.push(Sortable.create(listEl, {
                animation: 150,
                handle: '.section-drag-handle',
                draggable: '.section-box',
                onEnd: () => this.syncSectionsFromDom()
            }));

            listEl.querySelectorAll('.card-list').forEach(cardListEl => {
                this.sortables.push(Sortable.create(cardListEl, {
                    animation: 150,
                    handle: '.card-drag-handle',
                    draggable: '.card-box',
                    group: 'dv-cards',
                    onEnd: () => this.syncCardsFromDom()
                }));
            });
        },
        destroySortables() {
            this.sortables.forEach(s => {
                if (s && s.destroy) s.destroy();
            });
            this.sortables = [];
        },
        syncSectionsFromDom() {
            const listEl = this.$refs.sectionList;
            if (!listEl) return;
            const ordered = [];
            Array.from(listEl.children).forEach(el => {
                const id = el.getAttribute('data-section-id');
                const section = this.dataForm.sections.find(s => s._id === id);
                if (section) ordered.push(section);
            });
            this.dataForm.sections = ordered;
        },
        syncCardsFromDom() {
            const listEl = this.$refs.sectionList;
            if (!listEl) return;
            const cardMap = {};
            this.dataForm.sections.forEach(s => s.cards.forEach(c => { cardMap[c._id] = c; }));
            listEl.querySelectorAll('.section-box').forEach(sectionEl => {
                const sectionId = sectionEl.getAttribute('data-section-id');
                const section = this.dataForm.sections.find(s => s._id === sectionId);
                if (!section) return;
                const ordered = [];
                sectionEl.querySelectorAll('.card-list > .card-box').forEach(cardEl => {
                    const cardId = cardEl.getAttribute('data-card-id');
                    const card = cardMap[cardId];
                    if (card) ordered.push(card);
                });
                section.cards = ordered;
            });
        }
    }
};
</script>

<style>
.el-main {
    text-align: left;
}

.info-section {
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    margin-bottom: 14px;
    background: #fff;
    overflow: hidden;
}

.info-section-title {
    font-weight: bold;
    padding: 8px 14px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    color: #303133;
}

.info-section-body {
    padding: 14px;
}

.jsonb-item {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px;
    margin-top: 10px;
}

.section-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 60px;
}

.section-box {
    background: #eef4ff;
    border: 1px solid #b7d1f7;
    border-radius: 8px;
    padding: 16px;
}

.section-box-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.section-name-input {
    flex: 1;
}

.card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 30px;
}

.card-box {
    background: #ffffff;
    border: 1px solid #d5e0f2;
    border-radius: 6px;
    padding: 14px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.card-box-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.card-name-input {
    flex: 1;
    min-width: 0;
}

.card-type-select {
    width: 140px;
    flex-shrink: 0;
}

.card-src-select {
    width: 180px;
    flex-shrink: 0;
}

.add-card-btn-wrap {
    text-align: center;
    margin-top: 12px;
}

.add-card-btn,
.add-section-btn {
    width: 240px;
}

.drag-handle {
    display: inline-flex;
    flex-direction: column;
    gap: 2px;
    cursor: move;
    padding: 2px 4px;
    user-select: none;
}

.drag-handle i {
    width: 14px;
    height: 2px;
    background: #9aa7bd;
    border-radius: 1px;
}

.section-box.sortable-ghost,
.card-box.sortable-ghost {
    opacity: 0.4;
}

.section-box.sortable-drag,
.card-box.sortable-drag {
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.tips {
    font-size: 12px;
    color: #909399;
    margin-left: 10px;
}
</style>
